<template>
  <div class="c7 doc-content">
    <p class="c1"><span class="c2">■特定商取引法に基づく表示</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[事業者名等]</span></p>
    <p class="c1"><span class="c3">名称 : 株式会社10ANTZ</span></p>
    <p class="c1"><span class="c3">住所 : 〒150-0002</span></p>
    <p class="c1"><span class="c3">&nbsp; &nbsp; &nbsp; &nbsp;東京都渋谷区渋谷3―12－18 渋谷南東急ビル４階</span></p>
    <p class="c1"><span class="c3">代表者 : 髙澤 真</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[お問い合わせ先]</span></p>
    <p class="c1"><span class="c3">メール : support_hinakoi @10antz.jp</span></p>
    <p class="c1"><span class="c6">TEL : （代表）</span><span class="c8">03-6450-6351</span></p>
    <p class="c1"><span
        class="c3">※メールでのお問い合わせを推奨いたします。</span>
    </p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[販売価格]</span></p>
    <p class="c1"><span class="c3">商品毎に設定。各商品購入画面にて、販売価格（消費税込）を表示。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[送料]</span></p>
    <p class="c1"><span class="c3">発生しません。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[販売価格以外の費用]</span></p>
    <p class="c1"><span class="c3">インターネット接続料金、通信料金等はお客様のご負担となります。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[代金のお支払い時期およびお支払い方法]</span></p>
    <p class="c1"><span class="c3">1．お支払い時期</span></p>
    <p class="c1"><span class="c3">サービス提供の前となります。</span></p>
    <p class="c1"><span class="c3">2．お支払い方法</span></p>
    <p class="c1"><span
        class="c3">ゲーム内仮想通貨ご購入の際は、iOS端末をご利用の方はApp Store、Android端末をご利用の方はGoogleウォレット、決済代行会社（株式会社デジタルガレージ）のサービスをご利用の方はAppPayでのお支払いとなります。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[提供時期]</span></p>
    <p class="c1"><span class="c3">代金のお支払い後、速やかに提供させていただきます。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1" id="cancel"><span class="c2">[返品、キャンセル]</span></p>
    <p class="c1"><span class="c3">サービスの性質上、返品、キャンセルは出来ません。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[動作環境（推奨環境）]</span></p>
    <p class="c1"><span class="c3">以下の動作環境にてご利用ください。</span></p>
    <p class="c1"><span class="c3">＜iOS＞</span></p>
    <p class="c1"><span class="c3">・iOS 15.0以上</span></p>
    <p class="c1"><span class="c3">・iPhone 6s、iPad Air 2、iPad Mini 4以降の端末</span></p>
    <p class="c1"><span class="c3">・内蔵メモリ(RAM)：3GB以上 ※メモリは必要容量ではありません。</span></p>
    <p class="c1"><span class="c3">＜Android＞</span></p>
    <p class="c1"><span class="c3">・Android 8.0以上</span></p>
    <p class="c1"><span class="c3">・内蔵メモリ(RAM)：3GB以上 ※メモリは必要容量ではありません。<br/>「動作環境」に加えて下記の条件を満たす環境を推奨しています。<br/>SoC：Snapdragon 845 相当以上</span></p>
    <p class="c1"><span class="c3">※一部の端末ではご利用いただけない場合があります。</span></p>
    <p class="c0"><span class="c3"></span></p>
    <p class="c1"><span class="c2">[商品に関わる制限など]</span></p>
    <p class="c1"><span class="c3">各商品ページに記載します。</span></p>
    <p class="c1"><span class="c6">商品の販売期間、利用可能期間などをご確認の上、ご利用ください。</span></p>
  </div>
</template>

<script>
import resolution from '@/mixin/resolution';

export default {
  name: 'SpecifiedCommercialTransactions',
  mixins: [resolution],
  data() {
    return {};
  }
}
</script>

<style type="text/css">
ol {
  margin: 0;
  padding: 0
}

table td, table th {
  padding: 0
}

.c8 {
  background-color: #ffffff;
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16px;
  font-family: "Arial";
  font-style: normal
}

.c2 {
  background-color: #ffffff;
  color: #1d1c1d;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16px;
  font-family: "Arial";
  font-style: normal;
  padding-bottom: 6px;
  display: inline-block;
}

.c3 {
  background-color: #ffffff;
  color: #1d1c1d;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16px;
  font-family: "Arial";
  font-style: normal
}

.c0 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 11pt
}

.c5 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Arial";
  font-style: normal
}

.c1 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left
}

.c7 {
  background-color: #ffffff;
  max-width: 800px;
  padding: 20px 20px 50px;
  margin: 0 auto;
}

.c6 {
  background-color: #ffffff;
  font-size: 16px;
  color: #1d1c1d
}

.c4 {
  font-weight: 700
}

.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial"
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial"
}

h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left
}

h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial";
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left
}</style>
